import React from 'react';
import { Box, Typography, Chip, Button } from '@mui/material';
import { Notifications as NotificationsIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import './AlertsPage.css';

const AlertsPageHeader = ({ wsStatus, loading, onRefresh }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{
          width: 38, height: 38, borderRadius: 2,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(102, 126, 234, 0.25)',
        }}>
          <NotificationsIcon sx={{ color: 'white', fontSize: 22 }} />
        </Box>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '1.25rem', fontWeight: 800, color: '#1e293b', lineHeight: 1.2 }}>
              {t('alerts.pageTitle')}
            </Typography>
            <Chip
              icon={<Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: wsStatus.color, ml: 0.5 }} />}
              label={wsStatus.text}
              size="small"
              sx={{
                height: 20, fontSize: '0.62rem', fontWeight: 600,
                bgcolor: alpha(wsStatus.color, 0.1),
                color: wsStatus.color,
              }}
            />
          </Box>
          <Typography sx={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 500 }}>
            {t('alerts.pageSubtitle')}
          </Typography>
        </Box>
      </Box>

      <Button
        variant="outlined"
        size="small"
        startIcon={<RefreshIcon className={loading ? 'spinning' : ''} sx={{ fontSize: 16 }} />}
        onClick={onRefresh}
        disabled={loading}
        sx={{ fontSize: '0.75rem', fontWeight: 600, minHeight: 32, textTransform: 'none' }}
      >
        {loading ? t('alerts.refreshing') : t('alerts.refresh')}
      </Button>
    </Box>
  );
};

export default AlertsPageHeader;
